import type { ClientGame } from '@client/entity/client-game/domain/model/client-game.model';
import { MissingGamesUserClientError } from '@client/entity/current-client-user/domain/error/missing-games-user-client.error';

export class CurrentClientUserClient {
  public constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly accessCode: string | null = null,
    public readonly logo: string | null = null,
    public games: ClientGame[] = [],
    public readonly hasActiveSubscription: boolean,
    public readonly subscriptionStartDate: string | null = null,
    public readonly subscriptionEndDate: string | null = null,
  ) {}

  public setGames(games: ClientGame[]): void {
    this.games = games;
  }

  public getFirstKnownGame(): ClientGame {
    if (!this.games.length) {
      throw new MissingGamesUserClientError(this.id);
    }

    return this.games[0];
  }
}
